import { createAsyncThunk } from "@reduxjs/toolkit";
import { getGoogleUserInfo } from "../services/loginService";

export const getGoogleUser = createAsyncThunk("google/userInfo", () => {
  return getGoogleUserInfo();
});


